(ns renolit-roofing-service.layout.form.form-item.radio-button-group
  (:require [re-frame.core :as rf]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.localization :refer [t]]))

(def ^:const default-choice-id-kw :id)
(def ^:const default-choice-display-name-kw :name)

(defn- get-choice-id
  [choice
   {:keys [choice-id-kw] :as _opts
    :or {choice-id-kw default-choice-id-kw}}]
  (get choice choice-id-kw))

(defn- get-choice-display-name
  [choice
   {:keys [choice-display-name-kw] :as _opts
    :or {choice-display-name-kw default-choice-display-name-kw}}]
  (get choice choice-display-name-kw))

(defn- on-change-event-handler
  [opts choice]
  (fn [_]
    (let [choice-id (get-choice-id choice opts)]
      (form.form-item/on-change-event-handler opts :on-change choice-id))))

(defn- radio-button
  [_choice _opts _group-id]
  (let [component-id (str (random-uuid))]
    (fn [choice {:keys [state path css-class-prefix disabled?] :as opts} group-id]
      (let [choice-id (get-choice-id choice opts)
            choice-label (get-choice-display-name choice opts)
            checked? (= (get-in @state path) choice-id)]
        [:div.radio-button-group__radio-button
         {:class (when css-class-prefix (str css-class-prefix "__radio-button"))}
         [:input
          {:id component-id
           :type "radio"
           :name group-id
           :checked (boolean checked?)
           :on-change (on-change-event-handler opts choice)
           :disabled (boolean disabled?)
           :class (when css-class-prefix (str css-class-prefix "__input"))}]
         [:label
          {:for component-id
           :class (when css-class-prefix (str css-class-prefix "__label"))}
          choice-label]]))))

(defmethod form.form-item/form-item-component :radio-button-group
  [{:keys [context path] :as _opts}]
  (let [group-id (str (random-uuid))
        form-errors (rf/subscribe [::form.error/errors context path])]
    (fn [{:keys [disabled? choices css-class-prefix
                 full-line? label label-transl-kw]
          :as opts}]
      [:div.form-item.radio-button-group
       {:class [(when disabled? "form-item--disabled")
                (when css-class-prefix css-class-prefix)
                (when full-line? "form-item--full-line")
                (when (seq @form-errors) "form-item--error")]}
       (when (or label-transl-kw label)
         [:label.form-item__label
          (cond-> {}
            css-class-prefix
            (assoc :class (str css-class-prefix "__label"))

            (seq @form-errors)
            (assoc :title (form.error/form-error->msg (first @form-errors))))
          (or (t [label-transl-kw]) label)])
       [:div.radio-button-group__radio-buttons
        {:class (when css-class-prefix
                  (str css-class-prefix "__radio-buttons"))}
        (for [choice choices
              :let [choice-id (get-choice-id choice opts)]]
          ^{:key (str "radio-button__" choice-id)}
          [radio-button choice opts group-id])]])))
